import { useQueryClient } from '@tanstack/react-query';
import { catalogMappingKeys } from '../lib/query-keys';

/*
 * Refreshes every mapping list and count: the Mapping tab's queues and header
 * counts, the mapped and unmapped listings, the sidebar's unmapped count.
 */
export function useInvalidateMapping() {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: catalogMappingKeys.mappableLists(),
    });
}
